var path = 'public/app/plugins/datasource/grafana/partials/query.editor.html';
var html = "<query-editor-row query-ctrl=ctrl can-collapse=false>\n\t<div class=gf-form-inline>\n\t\t<div class=gf-form>\n\t\t\t<label class=gf-form-label>Test data: random walk</label>\n\t\t</div>\n\n\t\t<div class=\"gf-form gf-form--grow\">\n\t\t\t<div class=\"gf-form-label gf-form-label--grow\"></div>\n\t\t</div>\n\t</div>\n</query-editor-row>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./public/app/plugins/datasource/grafana/partials/query.editor.html
// module id = 872
// module chunks = 2